<template>
  <div :style="{ width: '30px', height: props.height + 'px' }">
    <Charts :option="option" />
  </div>
</template>

<script setup lang="ts">
import { computed, watch } from "vue";
import Charts from "@/components/Charts";
import { EChartsOption } from "echarts";

interface Props {
  value: number;
  color: string;
  max: number;
  type?: string;
  height?: number;
}
const props = withDefaults(defineProps<Props>(), {
  value: 0,
  max: 100,
  height: 80,
});

// watch(
//   () => props,
//   (props) => {
//     console.log("[ZJL]🚀 ~ watch ~ props.type:", props.type);
//     console.log("[ZJL]🚀 ~ watch ~ props.value:", props.value);
//     console.log("[ZJL]🚀 ~ watch ~ props.max:", props.max);
//     console.log("[ZJL]🚀 ~ watch ~ props.color:", props.color);
//   },
//   { deep: true }
// );

// <svg t="1730337195385" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1601" width="200" height="200"><path d="M631.808 822.272L510.464 1024l-118.272-201.728h79.872V0h79.872v822.272z" fill="#7ECF51" p-id="1602"></path></svg>

// 修正 SVG 路径
const path = "path://M0 0L40 0L40 100L0 100Z";
// "path://M631.808 201.728L510.464 0l-118.272 201.728h55.872V800h130.872V201.728z";
//"path://M631.808 201.728L510.464 0l-118.272 201.728h79.872V1024h79.872V201.728z";

const option = computed(() => {
  let barWidth = "8px";

  const options = {
    animation: false,
    backgroundColor: "rgba(0,0,0,0.0)",
    grid: {
      top: 0,
      bottom: 0,
    },
    color: [props.color, "rgba(0,0,0,.1)"],
    xAxis: {
      data: [],
      axisTick: {
        show: false,
      },
      splitLine: { show: false },
      axisLabel: {
        show: false,
      },
      axisLine: {
        show: false,
      },
    },
    yAxis: {
      max: props.max,
      min: 0,
      splitLine: { show: false },
      axisLabel: {
        show: false,
      },
      axisLine: {
        show: false,
      },
    },
    series: [
      {
        type: "pictorialBar",
        name: "realValue",
        symbol: path,
        // z: 10,
        symbolBoundingData: props.max,
        data: [
          {
            value: props.value,
            symbolClip: true,
          },
        ],
        z: 3,
      },
      {
        type: "pictorialBar",
        barGap: -200, // 使柱子之间没有间隔
        itemStyle: {
          color: "#999",
        },
        symbolRepeat: "fixed",
        symbolMargin: 4,
        symbol: "Rect",
        symbolClip: true,
        symbolSize: [10, 2],
        symbolPosition: "start",
        symbolOffset: [0, -5],
        data: [{ value: props.max }],
        z: 3,
      },
      //   {
      //     type: "bar",
      //     name: 1,
      //     barGap: "-100%", // 使柱子之间没有间隔
      //     barWidth: barWidth,
      //     legendHoverLink: false,
      //     symbolRepeat: true,
      //     silent: true,
      //     itemStyle: {
      //       color: {
      //         type: "linear",
      //         x: 0,
      //         y: 0,
      //         x2: 0,
      //         y2: 1,
      //         colorStops: [
      //           {
      //             offset: 0,
      //             color: "#ff0000", // 0% 处的颜色
      //           },
      //           {
      //             offset: 1,
      //             color: "#00ff00", // 100% 处的颜色
      //           },
      //         ],
      //       },
      //     //   shadowBlur: 4,
      //     //   shadowColor: "#74ddff",
      //     },
      //     data: [{ value: 10 }],
      //     z: 2,
      //   },
      {
        type: "pictorialBar",
        name: "background",
        symbol: path,
        symbolBoundingData: props.max,
        data: [
          {
            value: 20,
            animationDuration: 0,
          },
        ],
        z: 1,
      },
    ],
  } as EChartsOption;
  return options;
});
</script>
<style scoped>
.chart {
  height: 100%;
  width: 100%;
}
</style>
